export const activityStates = ['Draft', 'Cancelled', 'Active', 'Complete', 'Overdue'];
